// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/enterprise-admin/organization/OrganizationSectionCard.jsx

import React from "react";

export default function OrganizationSectionCard({
  eyebrow,
  title,
  description,
  children,
  className = "",
}) {
  return (
    <section className={`enterprise-admin-organization-card ${className}`.trim()}>
      <header className="enterprise-admin-organization-card-header">
        {eyebrow ? <p className="enterprise-admin-eyebrow">{eyebrow}</p> : null}
        <h3>{title}</h3>
        {description ? <p>{description}</p> : null}
      </header>
      <div className="enterprise-admin-organization-card-body">{children}</div>
    </section>
  );
}
